export default "__VITE_ASSET__nxO17DQ___"